import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {getZones} from "apollo/queries/getZones";
import {updateZoneMutation} from "apollo/mutations/updateZone";
import {createZoneMutation} from "apollo/mutations/createZone";
import {deleteZoneMutation} from "apollo/mutations/deleteZone";
import {fetchZonesSuccess, updateZoneSuccess,
createZoneSuccess, deleteZoneSuccess} from "../actions/Zone";
import {fetchError} from "../actions/Common";
import {client} from "apollo/client";

import {
  CREATEZONE,
  UPDATEZONE,
  DELETEZONE,
  FETCHZONES,
} from "constants/ActionTypes";

const getZonesRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: getZones,
      variables: {
        application: applicationId
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createZoneRequest = async (input) => {
  console.log('input', input);
  let { data, error } = await client.mutate({
    mutation: createZoneMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const updateZoneRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: updateZoneMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const deleteZoneRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteZoneMutation,
      variables: {
        zoneId: input
      }
    });

    console.log('data', data);

    if (data.deleteZoneById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Zone not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

function* getZonesCall({payload}) {
  console.log('getZonesCall', payload);
  const {applicationId} = payload;

  try {
    const fetchedZones = yield call(getZonesRequest, applicationId);
    yield put(fetchZonesSuccess(fetchedZones, applicationId));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* createZoneCall({payload}) {

  try {
    const {createZone} = yield call(createZoneRequest, payload);
    yield put(createZoneSuccess(createZone));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateZoneCall({payload}) {
  try {
    const {updateZone} = yield call(updateZoneRequest, payload);
    yield put(updateZoneSuccess(updateZone));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteZoneCall({payload}) {

  try {
    const deletedZone = yield call(deleteZoneRequest, payload);
    yield put(deleteZoneSuccess(deletedZone));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

export function* fetchZones() {
  yield takeEvery(FETCHZONES, getZonesCall);
}

export function* updateZone() {
  yield takeEvery(UPDATEZONE, updateZoneCall);
}

export function* createZone() {
  yield takeEvery(CREATEZONE, createZoneCall);
}

export function* deleteZone() {
  yield takeEvery(DELETEZONE, deleteZoneCall);
}

export default function* rootSaga() {
  yield all([
  fork(updateZone),
  fork(createZone),
  fork(deleteZone),
  fork(fetchZones)]);
}
